/* eslint-disable */
import {
  Swiper,
  Navigation,
  Pagination,
  Thumbs,
} from 'swiper';

Swiper.use([
  Navigation,
  Pagination,
  Thumbs,
]);


const init = (gallery: HTMLElement) => {
  const slider = gallery.querySelector('.wpb-gallery__slider') as HTMLElement;
  const thumbs = gallery.querySelector('.wpb-gallery__thumbs') as HTMLElement;
  
  const mainSlider = new Swiper(slider, {
    loop: true,
    speed: 500,
    autoHeight: true,
    keyboard: true,
    freeMode: true,
    watchSlidesProgress: true,
    preventClicks: false,
    spaceBetween: 24,
    preventClicksPropagation: false,

    slideActiveClass: 'slider__slide--active',

    pagination: {
      el: slider.querySelector('.slider__pagination') as HTMLElement,
      modifierClass: 'slider__pagination--',
      bulletClass: 'slider__bullet',
      bulletActiveClass: 'slider__bullet--active',
      clickable: true,
      clickableClass: 'slider__pagination--clickable',
    },

    navigation: {
      nextEl: slider.querySelector('.slider__nav--next') as HTMLElement,
      prevEl: slider.querySelector('.slider__nav--prev') as HTMLElement,
      disabledClass: 'slider__nav--disabled',
    },
  });

  const thumbsSlider = new Swiper(thumbs, {
    loop: true,
    speed: 500,
    slidesPerView: 4,
    spaceBetween: 24,
    slideToClickedSlide: true,
    watchSlidesProgress: true,

    preventClicks: false,
    preventClicksPropagation: false,

    navigation: {
      nextEl: thumbs.querySelector('.slider__nav--next') as HTMLElement,
      prevEl: thumbs.querySelector('.slider__nav--prev') as HTMLElement,
      disabledClass: 'slider__nav--disabled',
    },

    thumbs: {
      swiper: mainSlider,
    },
  });

  const variations: NodeListOf<HTMLElement> = document.querySelectorAll('.product-options__option');
  const firstSlideImages: NodeListOf<HTMLImageElement> = document.querySelectorAll('.swiper-slide[data-swiper-slide-index="0"] img');
  const firstSlideSources: NodeListOf<HTMLSourceElement> = document.querySelectorAll('.swiper-slide[data-swiper-slide-index="0"] source') ;

if(variations) {
  variations.forEach(variation => {
    variation.addEventListener('click', () => {
      // Update each image and source
      firstSlideImages.forEach(img => {
        img.src = variation.dataset.image;
        img.srcset = variation.dataset.image;
      });

      firstSlideSources.forEach(source => {
        source.src = variation.dataset.image;
        source.srcset = variation.dataset.image;
      });

      // Move the slider to the first slide in the loop
      mainSlider.slideToLoop(0);
    });
  });
}


  // thumbsSlider.controller.control = mainSlider;
  // mainSlider.controller.control = thumbsSlider;
  return { thumbsSlider, mainSlider };
};

export default init;
